import { Backdrop, CircularProgress } from "@mui/material"
import { AppContext } from "../context";
import { useContext, useEffect, useState } from "react";

export const Loading = () => {
    const {loading} = useContext<any>(AppContext);
    const [open, setOpen] = useState(loading)
    
    useEffect(() => {setOpen(loading)},[loading])
     return(
        <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
     )
}